import type { IconNode } from '../types';

/**
 * @name triangle-stripes
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMuNzUgNGEyIDIgMCAwIDAtMy41IDBMMi4yIDE4QTIgMi4xIDAgMCAwIDQgMjFoMTZhMiAyIDAgMCAwIDEuNzUtM1oiIC8+CiAgPHBhdGggZD0iTTcuNSA5aDkiIC8+CiAgPHBhdGggZD0iTTUuNSAxM2gxMyIgLz4KICA8cGF0aCBkPSJNMyAxN2gxOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/triangle-stripes
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const triangleStripes: IconNode = [
  [
    'path',
    { d: 'M13.75 4a2 2 0 0 0-3.5 0L2.2 18A2 2.1 0 0 0 4 21h16a2 2 0 0 0 1.75-3Z', key: '12co1r' },
  ],
  ['path', { d: 'M7.5 9h9', key: 'upbddf' }],
  ['path', { d: 'M5.5 13h13', key: 'c1b3zl' }],
  ['path', { d: 'M3 17h18', key: '3xqu03' }],
];

export default triangleStripes;
